import React, { useState } from 'react'
import ProfileWrapper from './ProfileWrapper'
import style from './style.module.sass'
import { useTheme } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { MenuItem, Select, TextField } from '@material-ui/core'
import { ArrowDropDown } from '@material-ui/icons'
import TLServiceComponent from '../../contexts/TLServiceComponent'
import { useActions } from '../../utils/action-helper'
import { userSaveOption, userSetOption } from '../../actions'
import { convertJSONToObject } from '../../utils'
import config from '../../config'

export default function ProfileRagComponent () {
  const tlService = React.useContext(TLServiceComponent)
  const { theme: { bgColors, borderColors, colors } } = useTheme()
  const { t } = useTranslation()

  const token = useSelector(state => state.userData.token)
  const userId = useSelector(state => state.userData.user.id)

  const storageRagSettings = convertJSONToObject(
    useSelector(state => state.userData?.user?.user_options?.rag_settings),
    config.defaultRagSettings
  )

  const [chunkMethod, setChunkMethod] = useState(storageRagSettings.chunkMethod)
  const [minChunkSize, setMinChunkSize] = useState(storageRagSettings.minChunkSize)

  const { actionUserSetOption, actionUserSaveOption } = useActions({
    actionUserSetOption: userSetOption,
    actionUserSaveOption: userSaveOption(tlService),
  })

  function saveRagSettings (name, value) {
    const newSettings = { ...storageRagSettings, [name]: value }
    actionUserSetOption('rag_settings', JSON.stringify(newSettings))
    actionUserSaveOption(token, userId, 'rag_settings', JSON.stringify(newSettings))
  }

  return (
    <ProfileWrapper>
      <div
        style={{
          color: colors.colorPrimary500,
          borderColor: borderColors.borderPrimary1000,
        }}
        className={style.blockInternal}
      >
        <ul className={`mt-4 p-0 list-unstyled`}>
          <li
            style={{ backgroundColor: bgColors.bgPrimary0, borderRadius: 10, fontSize: '18px' }}
            className={`d-flex align-items-center justify-content-between pr-3 pl-3 mb-4`}
          >
            <p className={`m-0 ${style.title}`}>
              <b>{t('batch-modal-rag-chunk-method')}</b>
            </p>
            <Select
              onChange={e => {
                setChunkMethod(e.target.value)
                saveRagSettings('chunkMethod', e.target.value)
              }}
              variant="outlined"
              value={chunkMethod}
              className={`p-0`}
              style={{
                borderRadius: 18,
                color: colors.colorText,
                fontSize: '0.875rem',
                border: `1px solid ${borderColors.borderPrimary100}`,
              }}
              IconComponent={(props) => (
                <ArrowDropDown {...props} style={{ color: colors.colorText }} />
              )}
              MenuProps={{
                PaperProps: {
                  style: {
                    backgroundColor: bgColors.bgPrimary200,
                    color: colors.colorText,
                    fontSize: '0.875rem',
                  },
                }
              }}
            >
              <MenuItem value={0}>{t('batch-modal-rag-chunk-method-paragraph')}</MenuItem>
              <MenuItem value={1}>{t('batch-modal-rag-chunk-method-llm')}</MenuItem>
              <MenuItem value={2}>{t('batch-modal-rag-chunk-method-sentence')}</MenuItem>
            </Select>
          </li>
          <li
            style={{ backgroundColor: bgColors.bgPrimary0, borderRadius: 10, fontSize: '18px' }}
            className={`d-flex align-items-center justify-content-between pr-3 pl-3 mb-4`}
          >
            <p className={`m-0 ${style.title}`}>
              <b>{t('batch-modal-rag-min-chunk-size')}</b>
            </p>
            <TextField
              size="small"
              variant="outlined"
              type="number"
              value={minChunkSize}
              InputProps={{ style: { color: colors.colorText } }}
              onChange={e => setMinChunkSize(e.target.value)}
              onBlur={e => saveRagSettings('minChunkSize', Number(e.target.value))}
            />
          </li>
        </ul>
      </div>
    </ProfileWrapper>
  )
}
